import { render, staticRenderFns } from "./TdWorkflowhistory.vue?vue&type=template&id=095f0892&"
import script from "./TdWorkflowhistory.vue?vue&type=script&lang=js&"
export * from "./TdWorkflowhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports